import React, { useEffect, useRef, useState } from "react";

/**
 * Image that fades/scales in smoothly once loaded (including cached images).
 */
const SmoothImage = ({
  className = "",
  onLoad,
  alt = "",
  reflect = false,
  ...props
}) => {
  const imgRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const img = imgRef.current;
    if (img?.complete && img.naturalWidth > 0) {
      setLoaded(true);
    }
  }, [props.src]);

  const handleLoad = (event) => {
    setLoaded(true);
    onLoad?.(event);
  };

  return (
    <span
      className={`sv-smooth-img${reflect ? " sv-smooth-img--reflect" : ""}${
        loaded ? " is-loaded" : ""
      }${className ? ` ${className}` : ""}`}
    >
      <img
        ref={imgRef}
        alt={alt}
        decoding="async"
        onLoad={handleLoad}
        {...props}
      />
    </span>
  );
};

export default SmoothImage;
